import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { AdSlot } from "~/components/advertisement/ad-slots/ad-slot";

import ImgStyleStories from "./img-style-stories.svg";

type ContainerProps = {
  $backgroundImages?: string[];
};
export const Container = styled.div<ContainerProps>`
  inline-size: 100%;
  block-size: 100vh;

  &::before {
    position: fixed;
    inset-inline: 0;
    content: "";
    z-index: -1;

    inline-size: 100%;
    block-size: 100vh;

    background: ${props =>
      props.$backgroundImages?.map(image => `url(${image})`).join(", ") ?? "#222222"};
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    filter: blur(20px) brightness(40%);
    transform: scale(1.1);
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;

  inline-size: 100%;
  margin-block: 40px 97px;
  margin-inline: 20px;

  ${props => props.theme.breakpoints.up("xLargeDesktop")} {
    margin-inline: 60px;
  }
`;

export const SliderWrapper = styled.div`
  position: relative;

  block-size: 100%;
  max-inline-size: 700px;
  max-block-size: 1012px;
  padding-block: 0;
  padding-inline: 70px;
  aspect-ratio: 185 / 253;
`;

export const Slides = styled.div`
  position: relative;

  block-size: 100%;

  border-radius: 20px;
  /* hack to fix this border-radius in safari */
  transform: translateZ(0);

  overflow: hidden;
`;

export const Section = styled.div`
  position: relative;
  inset-block-start: 0;
  inset-inline-start: 0;

  display: flex;
  justify-content: center;

  inline-size: 100%;
  block-size: 100%;
`;

export const LHSContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: end;

  margin-inline-end: 20px;
  ${props => props.theme.breakpoints.up("largeDesktop")} {
    margin-inline-end: 60px;
  }

  ${props => props.theme.breakpoints.up("xLargeDesktop")} {
    margin-inline-end: 158px;
  }
`;

export const LHSWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  inline-size: 211px;
`;

export const LHSContent = styled.div`
  color: #e5e5e5;
  font-weight: 300;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 22px;
`;

export const StyledImgStyleStories = styled(ImgStyleStories)`
  color: #000000;
`;

export const RHSBannerAdSlotWrapper = styled.div`
  flex: 1;

  margin-inline-start: 20px;
  ${props => props.theme.breakpoints.up("largeDesktop")} {
    margin-inline-start: 80px;
  }
`;

export const StyledAdSlot = styled(AdSlot)`
  align-items: start;
`;
